import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../../Navigation/NavigationContainer';
import Validation from '../../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../HomePurchaseWorkflowConstants';
import AdvForm from '../../../../CommonComponents/AdvForm';
import { isNumeric } from '../../../../../js/app/react/validators';
import InputDollar from '../../../InputDollar/InputDollarView';

export const withEmptyStringWhenNull = value => (value === null ? '' : value);

export const validator = amount => () => {
  if (!isNumeric(amount) || +amount < 0) {
    return ['Please specify an estimated amount'];
  }
  return [];
};

const ExpectedAnnualHomeownerInsurance = ({
  workflowId,
  branch,
  nullableAnnualHomeownersInsurance,
  onExpectedAnnualHomeownerInsuranceChanged,
}) => (
  <AdvWorkflowStep branch={branch} workflowId={workflowId}>
    <Validation
      workflowId={workflowId}
      validationId={`${HOME_PURCHASE_GOAL_GRAPH_NODE}.HomeInsurancePerYear`}
    />
    <h2>What is the expected annual homeowners insurance?</h2>
    <AdvForm>
      <ul className="horizontal">
        <li>
          <InputDollar
            isUnder
            placeholderClassName="adv-workflows-placeholder-large"
            placeholder="Home Insurance"
            className="md"
            value={withEmptyStringWhenNull(nullableAnnualHomeownersInsurance)}
            onChange={onExpectedAnnualHomeownerInsuranceChanged(workflowId)}
            id="adv-home-insurance"
          />
        </li>
      </ul>
    </AdvForm>

    <Navigation
      nextIterators={[]}
      dirtyGraphNodes={[]}
      validator={validator(nullableAnnualHomeownersInsurance)}
      validationId={`${HOME_PURCHASE_GOAL_GRAPH_NODE}.HomeInsurancePerYear`}
      workflowId={workflowId}
      backendKey={HOME_PURCHASE_GOAL_GRAPH_NODE}
    />
  </AdvWorkflowStep>
);

ExpectedAnnualHomeownerInsurance.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: PropTypes.string.isRequired,
  nullableAnnualHomeownersInsurance: PropTypes.number.isRequired,
  onExpectedAnnualHomeownerInsuranceChanged: PropTypes.func.isRequired,
};

export default ExpectedAnnualHomeownerInsurance;
